import React, { ReactElement } from 'react';
import { NavigationButtons } from '../../shared/NavigationButtons';
import { Form, Formik } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';

import { lifeInsuranceTypeSchema } from '../../schema';
import { LifeInsuranceTypeStepForm } from './LifeInsuranceTypeStepForm';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function LifeInsuranceTypeStep(): ReactElement {
  const dispatch = useDispatch();
  const { typeOfLifeInsurancePossessed: typeOfLifeInsurancePossessed } =
    useSelector((state: RootState) => state.steps);

  const formRef = useFormInteractionTracking('kind_of_life_ins');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }
  return (
    <CardPadding>
      <CardHeader
        header="What kind of life insurance do you have?"
        subHeader=" Term life insurance lasts for a specified time period, like 20 or 30
        years. Cash value (aka whole life) life insurance lasts your entire
        life. And there's usually a savings account inside the policy. It's okay
        if you're not sure what you have! We can help."
      />
      <Formik
        initialValues={{ typeOfLifeInsurancePossessed }}
        onSubmit={onSubmit}
        validationSchema={lifeInsuranceTypeSchema}
      >
        <Form ref={formRef}>
          <LifeInsuranceTypeStepForm name="typeOfLifeInsurancePossessed" />
          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { LifeInsuranceTypeStep };
